import { AppThunkAction, AppThunkActionAsync } from "..";
import * as actions from "./actions";
import clientApi from "../../api/client";
import { selectClientId } from "../client";

export function getClientFolder(folderId: string): AppThunkActionAsync {
  return async (dispatch, getState) => {
    dispatch(actions.clientFolderFetchRequest());
    const clientId = selectClientId(getState());
    try {
      const folder = await clientApi.getClientFolder(clientId!, folderId);
      dispatch(actions.clientFolderFetchSuccess(folder.data));
    } catch {
      dispatch(actions.clientFolderFetchError());
    }
  };
}

export function getDefaultClientFolder(): AppThunkAction {
  return (dispatch) => {
    dispatch(actions.clientFolderFetchSuccess([]));
  };
}
